import { gql, useMutation } from '@apollo/client';
import { useRef, useState } from 'react';

import { FormInput, FormPanel } from 'components/FormPanel';

import Button from 'primitives/Button';

import alIndiaLogo from 'media/alIndiaLogo.png';

const CREATE_ACCREDITATION_INTEREST = gql`
  mutation CreateAccreditationInterest($name: String!, $email: String!) {
    createAccreditationInterest(name: $name, email: $email)
  }
`;

export default function AccreditationInterestPage() {
  const [success, setSuccess] = useState(false);
  const [createInterest, { loading, error }] = useMutation(CREATE_ACCREDITATION_INTEREST);
  const buttonRef = useRef<any>(null);

  const handleSubmit = async (data: any) => {
    const { name, email } = data;
    try {
      await createInterest({ variables: { name, email } });
      setSuccess(true);
    } catch (e) {
      console.error(e);
    }
  };

  if (success) {
    return (
      <div className="flex min-h-screen flex-col justify-center py-6 px-4 sm:py-12 sm:px-6 lg:px-8 bg-gray-50">
        <div className="mx-auto w-full max-w-md">
          <img className="mx-auto h-12 w-auto" src={alIndiaLogo} alt="AngelList India" />
          <p className="mt-2 text-center text-sm text-gray-600">
            Thank you for your interest in the accreditation process, our team will get in touch
            with you shortly on the next steps.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-gray-50 flex flex-col justify-center py-6 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div className="absolute inset-0 h-full w-full bg-gray-50 flex items-center justify-center overflow-hidden z-0">
        <svg
          className="w-full h-full text-gray-200"
          fill="currentColor"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="#E0E7FF" opacity="0.5" />
          <circle cx="50" cy="50" r="20" fill="#4F46E5" opacity="0.1" />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="text-gray-400 text-lg font-medium"></div>
        </div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-md">
        <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
          <div className="mx-auto w-full max-w-md">
            <img className="mx-auto h-12 w-auto" src={alIndiaLogo} alt="AngelList India" />
            <h2 className="mt-6 text-center text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">
              Get Accredited
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Enter your details below to initiate the accreditation process.
            </p>
          </div>

          <div className="mt-8">
            <FormPanel
              onSubmit={handleSubmit}
              loading={loading}
              error={error?.message}
              buttonRef={buttonRef}
            >
              <FormInput
                fieldName="name"
                label="Full Name"
                type="text"
                defaultValue=""
                placeholder="Rakesh Sharma"
                validators={{ required: true }}
              />
              <FormInput
                fieldName="email"
                label="Email address"
                type="text"
                defaultValue=""
                placeholder="rakesh@example.com"
                validators={{ required: true, isEmail: true }}
              />
            </FormPanel>
            <div className="mt-6">
              <Button
                onClick={() => buttonRef.current?.submit()}
                loading={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Submit Interest
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
